// removed by extract-text-webpack-plugin
module.exports = {"progress":"progress__1z9jt","progressBar":"progressBar__2aeRA","contribution_wrapper":"contribution_wrapper__1YoLt","individual_contribution":"individual_contribution__DhCp8","contribution_percentage":"contribution_percentage__1yC4b","bar_step":"bar_step__T-w_x","label_line":"label_line__1kQIG","label_txt":"label_txt__3zcXK","label_percent":"label_percent__2cLNW","legend":"legend__12ySf","legendLabel":"legendLabel__Jd2HW","legendBlock":"legendBlock__2aPip","legendLabelText":"legendLabelText__am_8Z","legendCenter":"legendCenter__2BgtJ"};


//////////////////
// WEBPACK FOOTER
// ./components/contribution-indicator/style.scss
// module id = he22
// module chunks = 17